/**
* Marquee CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Marquee CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'marquee-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.marquee-cta__marquee' ).length ) {
        $( '.marquee-cta__marquee' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            autoWidth: true,
            gap: '2rem',
            drag: false,
            autoScroll: {
              speed: 1,
              pauseOnHover: false,
            },
            arrows: false,
            pagination: false,
          } ).mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'marquee-cta', COMPONENT );
} )( app );
